module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_cuadrada_marco_comida_44.d1e41ba3.png";